import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,addClass,on,findAllIn} from '@elements/dom-utils';
import Popover from 'bootstrap/js/dist/popover';

const selectors = {
    base: '.js-certificates',
    items: '.js-certificates__item',
    content: '.js-certificates__content'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let items = findAllIn(selectors.items, baseElement);
        let content = findAllIn(selectors.content, baseElement);

        items.forEach((item, index) => {
            const popover = new Popover(item, {
                html: true,
                trigger: 'manual',
                title: '',
                content: content[index],
                placement: 'top',
                customClass: 'certificate-popover',
                delay: {
                    "show": 100,
                    "hide": 100
                },
            });

            on('mouseover', function () {
                addClass('is-open', item);
                content[index].removeAttribute('hidden');
                popover.show();
            }, item);
            on('mouseout', function () {
                popover.hide();
                removeClass('is-open', item);
                content[index].setAttribute('hidden', true);
            }, item);
        })
    });
}
